import { useState, useEffect, useRef } from 'react';

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useOnScreen = <T extends Element = HTMLDivElement>(options?: IntersectionObserverInit) => {
  const ref = useRef<T>(null);
  const [isIntersecting, setIntersecting] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  // 1) Observer only drives isIntersecting
  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
    }, options);

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, options]);

  // 2) When isIntersecting becomes true, in a separate effect mark hasBeenVisible
  useEffect(() => {
    if (isIntersecting) {
      setHasBeenVisible(true);
    }
  }, [isIntersecting]);

  return [ref, isIntersecting, hasBeenVisible] as const;
};
